import { PageTitle } from "_metronic/layout/core";
import { CPLAnalytics } from "setup/appInsights/CPLAnalytics";
import AppBackButton from "../shared/appBackButton/AppBackButton";
import DocumentInstancesTable from "./components/DocumentInstancesTable";

const DocumentInstancesPage: React.FC = () => {
  return (
    <CPLAnalytics pageName="Document Instances">
      <AppBackButton backTo="/Documents" data-test-id="document-details__back-button" />
      <PageTitle breadcrumbs={[]}>Document Details</PageTitle>
      <DocumentInstancesTable />
    </CPLAnalytics>
  );
};

export default DocumentInstancesPage;
